import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SessionService } from '../../../services/session/session.service';
import { LifecycleAware } from '../../../utilities/rxjs.helpers';

@LifecycleAware()
@Component({
    selector: 'lsq-logout',
    templateUrl: './lsq-logout.component.html'
})
export class LsqLogoutComponent implements OnInit {
    constructor(private _sessionService: SessionService, private _activatedRoute: ActivatedRoute) {}

    public ngOnInit(): void {
        this._activatedRoute.queryParams.subscribe((queryParams) => {
            if (queryParams.immediate === 'true') {
                // The navitems use this queryParam to indicate we don't need to wait for bootup network traffic to settle.
                this._sessionService.logout();
            } else {
                // Forgive the 'magic number' timeout. It is needed only for when you hard navigate to `/logout`.
                // This isn't ever done by a user - just developers and e2e tests.
                // We don't currently have a good mechanism to tell us when all of the bootstraping network traffic has settled.
                // If you try to logout prior to that traffic settling, the session does not properly clear.
                setTimeout(() => {
                    this._sessionService.logout();
                }, 1500);
            }
        });
    }
}
